import type {
  ProposedRoute,
  RouteBuilderSession,
} from "../../../../../types/routeBuilder";
import { compareNames, firstRouteGroup } from "./routeGroups";

export type BuilderRouteGroup = {
  key: string;
  label: string;
  routes: ProposedRoute[];
};

export function groupBuilderRoutes(
  routes: ProposedRoute[],
  session: RouteBuilderSession,
): BuilderRouteGroup[] {
  if (session.builderMode !== "edit") {
    return [{ key: "__all__", label: "", routes }];
  }
  const groups = new Map<string, BuilderRouteGroup>();
  for (const route of routes) {
    const label = firstRouteGroup(session.routePersistence?.[route.id]?.tags);
    const existing = groups.get(label);
    if (existing) existing.routes.push(route);
    else groups.set(label, { key: label, label, routes: [route] });
  }
  return Array.from(groups.values()).sort((a, b) =>
    compareNames(a.label, b.label),
  );
}
